var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"smButton8 mt-4 buttonOutsetColor",attrs:{"disabled":_vm.nowGrade == 'none'}},[_vm._v(_vm._s(_vm.text1))])}
var staticRenderFns = []

export { render, staticRenderFns }